/* eslint-disable */
import { traverse, isPlainObject } from '@/lib/utils';

interface ValueInfo {
    current: any;
    old: any;
}

class Confirm {
    public val: ValueInfo;
    public constructor(val: ValueInfo) {
        this.val = val;
    }

    public confirm() {
        this.val.old = this.val.current;
    }
    public rollback() {
        this.val.current = this.val.old;
    }
}

/**
 * 改造对象，将current和old数据都存储
 */
function defineConfirmable(obj: any, key: string, val: any = null) {
    const _val = {
        current: val,
        old: val,
    };

    Object.defineProperty(obj, key, {
        configurable: true,
        enumerable: true,
        get() {
            return _val.current;
        },
        set(v) {
            _val.current = v;
        },
    });

    return new Confirm(_val);
}

export class Confirmable<T extends { [key: string]: any } = { [key: string]: any }> {
    [key: string]: any;

    constructor(obj: T) {
        const keys = Object.keys(obj);
        const confirms: Array<Confirm | Confirmable> = [];
        for (const key of keys) {
            if (isPlainObject(obj[key])) {
                const map = new Confirmable(obj[key]);
                this[key] = map;
                confirms.push(map);
            } else {
                confirms.push(defineConfirmable(this, key, obj[key]));
            }
        }

        Object.defineProperty(this, '__confirm__', {
            writable: true,
            configurable: false,
            enumerable: false,
            value: confirms,
        });
    }

    public set(keyOrPath: string, val: any) {
        const parts = keyOrPath.split('.');
        if (parts.length === 1) {
            this[keyOrPath] = val;
        } else {
            const last = parts.pop()!;
            const obj = traverse(this, parts);
            obj[last] = val;
        }
    }

    public confirm() {
        const obs = this.__confirm__ as Confirm[];
        for (const ob of obs) {
            ob.confirm();
        }
    }
    public rollback() {
        const obs = this.__confirm__ as Confirm[];
        for (const ob of obs) {
            ob.rollback();
        }
    }
}
